import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useDispatch, useSelector } from 'react-redux';
import { 
  FaArrowLeft, FaStar, FaPlus, FaMinus, FaCalendarAlt, FaClock, 
  FaShare, FaHeart, FaRegHeart, FaTruck, FaShieldAlt, FaLeaf,
  FaFire, FaUtensils, FaInfoCircle, FaCheckCircle, FaShoppingBag,
  FaRegClock, FaUsers, FaTag, FaImage, FaEye, FaTrash
} from 'react-icons/fa';
import { addOrderItem } from '../../redux/slices/tiffinSlice';
import { getColors } from '../../styles/colors';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

// Sample product data
const productData = {
  1: { 
    id: 1, 
    name: 'Butter Chicken', 
    price: 299, 
    rating: 4.8, 
    isVeg: false, 
    image: 'https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?w=600&h=400&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?w=600&h=400&fit=crop',
      'https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?w=600&h=400&fit=crop&crop=center',
      'https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?w=600&h=400&fit=crop&crop=center&rotate=10',
      'https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?w=600&h=400&fit=crop&crop=center&rotate=-10',
    ],
    description: 'Creamy & Rich butter chicken cooked in a traditional tandoor with aromatic spices and a rich tomato gravy.',
    category: 'North Indian',
    ingredients: 'Chicken, Butter, Cream, Tomato, Spices, Ginger, Garlic',
    nutrition: { calories: 450, protein: '35g', carbs: '15g', fat: '25g' },
    preparationTime: '25-30 min',
    serves: '2-3 people',
    isPopular: true,
    isVeg: false
  },
  2: { 
    id: 2, 
    name: 'Paneer Tikka', 
    price: 249, 
    rating: 4.6, 
    isVeg: true, 
    image: 'https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8?w=600&h=400&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8?w=600&h=400&fit=crop',
      'https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8?w=600&h=400&fit=crop&crop=center',
      'https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8?w=600&h=400&fit=crop&crop=center&rotate=10',
      'https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8?w=600&h=400&fit=crop&crop=center&rotate=-10',
    ],
    description: 'Smoky & Tasty paneer tikka marinated in yogurt and spices, grilled to perfection in a tandoor.',
    category: 'North Indian',
    ingredients: 'Paneer, Yogurt, Spices, Bell Peppers, Onion',
    nutrition: { calories: 320, protein: '25g', carbs: '12g', fat: '18g' },
    preparationTime: '20-25 min',
    serves: '2-3 people',
    isPopular: true,
    isVeg: true
  },
  3: { 
    id: 3, 
    name: 'Chicken Biryani', 
    price: 349, 
    rating: 4.9, 
    isVeg: false, 
    image: 'https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?w=600&h=400&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?w=600&h=400&fit=crop',
      'https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?w=600&h=400&fit=crop&crop=center',
      'https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?w=600&h=400&fit=crop&crop=center&rotate=10',
      'https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?w=600&h=400&fit=crop&crop=center&rotate=-10',
    ],
    description: 'Aromatic & Delicious chicken biryani layered with fragrant basmati rice, tender chicken, and exotic spices.',
    category: 'Biryani',
    ingredients: 'Chicken, Basmati Rice, Spices, Saffron, Fried Onions, Mint',
    nutrition: { calories: 550, protein: '40g', carbs: '45g', fat: '20g' },
    preparationTime: '35-40 min',
    serves: '3-4 people',
    isPopular: true,
    isVeg: false
  },
  4: { 
    id: 4, 
    name: 'Veg Biryani', 
    price: 249, 
    rating: 4.5, 
    isVeg: true, 
    image: 'https://images.unsplash.com/photo-1589302168068-964664d93dc0?w=600&h=400&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1589302168068-964664d93dc0?w=600&h=400&fit=crop',
      'https://images.unsplash.com/photo-1589302168068-964664d93dc0?w=600&h=400&fit=crop&crop=center',
      'https://images.unsplash.com/photo-1589302168068-964664d93dc0?w=600&h=400&fit=crop&crop=center&rotate=10',
      'https://images.unsplash.com/photo-1589302168068-964664d93dc0?w=600&h=400&fit=crop&crop=center&rotate=-10',
    ],
    description: 'Flavorful & Healthy vegetable biryani with mixed vegetables, aromatic rice, and traditional spices.',
    category: 'Biryani',
    ingredients: 'Mixed Vegetables, Basmati Rice, Spices, Saffron, Fried Onions',
    nutrition: { calories: 400, protein: '15g', carbs: '50g', fat: '15g' },
    preparationTime: '25-30 min',
    serves: '2-3 people',
    isPopular: false,
    isVeg: true
  },
  5: { 
    id: 5, 
    name: 'Gulab Jamun', 
    price: 99, 
    rating: 4.7, 
    isVeg: true, 
    image: 'https://images.unsplash.com/photo-1589119908994-c7e38c6cf05b?w=600&h=400&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1589119908994-c7e38c6cf05b?w=600&h=400&fit=crop',
      'https://images.unsplash.com/photo-1589119908994-c7e38c6cf05b?w=600&h=400&fit=crop&crop=center',
      'https://images.unsplash.com/photo-1589119908994-c7e38c6cf05b?w=600&h=400&fit=crop&crop=center&rotate=10',
      'https://images.unsplash.com/photo-1589119908994-c7e38c6cf05b?w=600&h=400&fit=crop&crop=center&rotate=-10',
    ],
    description: 'Sweet & Soft gulab jamun soaked in rose-flavored sugar syrup, the perfect dessert to end your meal.',
    category: 'Desserts',
    ingredients: 'Milk Solids, Sugar, Rose Water, Cardamom',
    nutrition: { calories: 180, protein: '4g', carbs: '30g', fat: '8g' },
    preparationTime: '10-15 min',
    serves: '2 people',
    isPopular: false,
    isVeg: true
  },
  6: { 
    id: 6, 
    name: 'Masala Dosa', 
    price: 149, 
    rating: 4.4, 
    isVeg: true, 
    image: 'https://images.unsplash.com/photo-1589301760014-d929f7239e7a?w=600&h=400&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1589301760014-d929f7239e7a?w=600&h=400&fit=crop',
      'https://images.unsplash.com/photo-1589301760014-d929f7239e7a?w=600&h=400&fit=crop&crop=center',
      'https://images.unsplash.com/photo-1589301760014-d929f7239e7a?w=600&h=400&fit=crop&crop=center&rotate=10',
      'https://images.unsplash.com/photo-1589301760014-d929f7239e7a?w=600&h=400&fit=crop&crop=center&rotate=-10',
    ],
    description: 'Crispy & Spicy masala dosa with a potato filling, served with coconut chutney and sambar.',
    category: 'South Indian',
    ingredients: 'Rice Batter, Potato, Onion, Spices, Coconut Chutney, Sambar',
    nutrition: { calories: 280, protein: '8g', carbs: '35g', fat: '12g' },
    preparationTime: '15-20 min',
    serves: '1 person',
    isPopular: false,
    isVeg: true
  },
};

const ProductDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.theme.mode);
  const isDark = theme === 'dark';
  const colors = getColors(isDark);
  
  const product = productData[id] || productData[1];
  const [quantity, setQuantity] = useState(1);
  const [isLiked, setIsLiked] = useState(false);
  const [activeImage, setActiveImage] = useState(0);
  
  // ✅ Multiple Date Selection States
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [selectedDates, setSelectedDates] = useState([]);
  const [selectedMealType, setSelectedMealType] = useState('Lunch');
  const [selectedTime, setSelectedTime] = useState('12:00 PM');
  const [showCalendar, setShowCalendar] = useState(false);
  const [tempDate, setTempDate] = useState(new Date());

  const mealTypes = ['Breakfast', 'Lunch', 'Dinner'];
  const timeSlots = [];
  for (let i = 8; i <= 22; i++) {
    const hour = i > 12 ? i - 12 : i;
    const ampm = i >= 12 ? 'PM' : 'AM';
    timeSlots.push(`${hour}:00 ${ampm}`);
    timeSlots.push(`${hour}:30 ${ampm}`);
  }

  // ✅ Add date to selected dates
  const handleAddDate = () => {
    const formattedDate = tempDate.toISOString().split('T')[0];
    if (!selectedDates.find(d => d.date === formattedDate)) {
      setSelectedDates([...selectedDates, { 
        date: formattedDate, 
        mealType: selectedMealType, 
        time: selectedTime,
        quantity: quantity
      }]);
      const nextDay = new Date(tempDate);
      nextDay.setDate(nextDay.getDate() + 1);
      setTempDate(nextDay);
    } else {
      alert('This date is already selected!');
    }
    setShowCalendar(false);
  };

  // ✅ Remove date
  const handleRemoveDate = (dateToRemove) => {
    setSelectedDates(selectedDates.filter(d => d.date !== dateToRemove));
  };

  // ✅ Confirm all schedules and go to checkout
  const handleConfirmAllSchedules = () => {
    if (selectedDates.length === 0) {
      alert('Please add at least one date');
      return;
    }
    
    selectedDates.forEach((schedule) => {
      const scheduledMeal = {
        ...product,
        scheduledDate: schedule.date,
        scheduledTime: schedule.time,
        mealTypeSelected: schedule.mealType,
        quantity: schedule.quantity,
        id: Date.now() + Math.random()
      };
      dispatch(addOrderItem({ item: scheduledMeal }));
    });
    
    setShowScheduleModal(false);
    setSelectedDates([]);
    navigate('/checkout');
  };

  const handleDateSelect = (date) => {
    setTempDate(date);
    setShowCalendar(false);
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', { 
      weekday: 'short', 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    });
  };

  const formatDateShort = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { 
      weekday: 'short', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  const VegIndicator = ({ isVeg }) => (
    <span className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-medium ${
      isVeg ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
    }`}>
      {isVeg ? '🌿 Vegetarian' : '🍗 Non-Vegetarian'}
    </span>
  );

  // Similar items
  const similarItems = Object.values(productData)
    .filter(p => p.id !== product.id)
    .slice(0, 4);

  return (
    <motion.div 
      className="py-4 max-w-6xl mx-auto px-4"
      style={{ backgroundColor: colors.background }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
    >
      {/* Back Button */}
      <button 
        onClick={() => navigate(-1)} 
        className="flex items-center gap-2 mb-4 px-4 py-2 rounded-full transition-all hover:scale-105"
        style={{ backgroundColor: colors.card, color: colors.text }}
      >
        <FaArrowLeft /> Back
      </button>

      {/* Main Product Card */}
      <div className="rounded-2xl overflow-hidden" style={{ backgroundColor: colors.card, border: `1px solid ${colors.border}` }}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 p-6">
          {/* Left - Image Section */}
          <div className="space-y-3">
            <div className="relative rounded-xl overflow-hidden bg-gray-100" style={{ height: '380px' }}>
              <img 
                src={product.images?.[activeImage] || product.image} 
                alt={product.name} 
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute top-4 left-4 flex gap-2">
                <div className="px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1" style={{ backgroundColor: 'rgba(0,0,0,0.75)', color: 'white' }}>
                  <FaStar className="text-yellow-400" /> {product.rating}
                </div>
                {product.isPopular && (
                  <div className="px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1" style={{ backgroundColor: '#FD8A36', color: 'white' }}>
                    <FaFire /> Popular
                  </div>
                )}
              </div>
              <button 
                onClick={() => setIsLiked(!isLiked)}
                className="absolute top-4 right-4 w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110"
                style={{ backgroundColor: 'rgba(255,255,255,0.9)', color: isLiked ? '#e74c3c' : '#666' }}
              >
                {isLiked ? <FaHeart /> : <FaRegHeart />}
              </button>
            </div>

            {/* Thumbnail Images */}
            <div className="grid grid-cols-4 gap-2">
              {(product.images || [product.image]).map((img, index) => (
                <div
                  key={index}
                  className={`rounded-lg overflow-hidden cursor-pointer transition-all duration-300 ${
                    activeImage === index ? 'ring-2 ring-primary' : 'hover:opacity-80'
                  }`}
                  style={{ height: '80px', backgroundColor: colors.inputBackground }}
                  onClick={() => setActiveImage(index)}
                >
                  <img 
                    src={img} 
                    alt={`${product.name} ${index + 1}`} 
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Right - Details */}
          <div className="space-y-4">
            <div>
              <h1 className="text-3xl font-bold" style={{ color: colors.text }}>{product.name}</h1>
              <div className="flex flex-wrap items-center gap-3 mt-2">
                <VegIndicator isVeg={product.isVeg} />
                <span className="text-sm" style={{ color: colors.textSecondary }}>{product.category}</span>
                <span className="w-1 h-1 rounded-full" style={{ backgroundColor: colors.textSecondary }}></span>
                <span className="text-sm flex items-center gap-1" style={{ color: colors.textSecondary }}>
                  <FaStar className="text-yellow-400" /> {product.rating}
                </span>
              </div>
            </div>

            <p className="text-base leading-relaxed" style={{ color: colors.textSecondary }}>
              {product.description}
            </p>

            <div className="flex flex-wrap gap-3">
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-full text-xs" style={{ backgroundColor: colors.inputBackground, color: colors.textSecondary }}>
                <FaRegClock /> {product.preparationTime}
              </div>
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-full text-xs" style={{ backgroundColor: colors.inputBackground, color: colors.textSecondary }}>
                <FaUsers /> {product.serves}
              </div>
            </div>

            <div className="flex items-center gap-3">
              <span className="text-3xl font-bold" style={{ color: colors.primary }}>₹{product.price}</span>
              <span className="text-sm line-through" style={{ color: colors.textSecondary }}>₹{product.price + 50}</span>
              <span className="text-xs font-semibold px-2 py-0.5 rounded-full" style={{ backgroundColor: '#27ae60', color: 'white' }}>15% OFF</span>
            </div>

            <div className="flex flex-wrap items-center gap-4 pt-2">
              <div className="flex items-center gap-3">
                <span className="text-sm" style={{ color: colors.textSecondary }}>Qty:</span>
                <div className="flex items-center gap-2">
                  <button
                    className="w-9 h-9 rounded-full border flex items-center justify-center transition-all hover:scale-105 active:scale-95"
                    style={{ borderColor: colors.border, color: colors.text, backgroundColor: colors.inputBackground }}
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                  >
                    <FaMinus className="text-xs" />
                  </button>
                  <span className="text-lg font-bold min-w-[30px] text-center" style={{ color: colors.text }}>{quantity}</span>
                  <button
                    className="w-9 h-9 rounded-full border flex items-center justify-center transition-all hover:scale-105 active:scale-95"
                    style={{ borderColor: colors.border, color: colors.text, backgroundColor: colors.inputBackground }}
                    onClick={() => setQuantity(quantity + 1)}
                  >
                    <FaPlus className="text-xs" />
                  </button>
                </div>
              </div>
              <button
                className="flex-1 sm:flex-none px-8 py-3 rounded-full font-semibold text-sm transition-all hover:scale-105 active:scale-95 flex items-center justify-center gap-2"
                style={{ backgroundColor: colors.primary, color: '#FFFFFF' }}
                onClick={() => setShowScheduleModal(true)}
              >
                <FaCalendarAlt /> Schedule Order
              </button>
            </div>

            {/* Nutrition */}
            <div className="rounded-xl p-4" style={{ backgroundColor: colors.inputBackground, border: `1px solid ${colors.border}` }}>
              <h4 className="font-semibold mb-3 text-sm flex items-center gap-2" style={{ color: colors.text }}>
                <FaInfoCircle style={{ color: colors.primary }} /> Nutrition Information
              </h4>
              <div className="grid grid-cols-4 gap-2 text-center">
                <div className="p-2 rounded-lg" style={{ backgroundColor: colors.card }}>
                  <p className="text-xl font-bold" style={{ color: colors.primary }}>{product.nutrition.calories}</p>
                  <p className="text-xs" style={{ color: colors.textSecondary }}>Calories</p>
                </div>
                <div className="p-2 rounded-lg" style={{ backgroundColor: colors.card }}>
                  <p className="text-xl font-bold" style={{ color: colors.primary }}>{product.nutrition.protein}</p>
                  <p className="text-xs" style={{ color: colors.textSecondary }}>Protein</p>
                </div>
                <div className="p-2 rounded-lg" style={{ backgroundColor: colors.card }}>
                  <p className="text-xl font-bold" style={{ color: colors.primary }}>{product.nutrition.carbs}</p>
                  <p className="text-xs" style={{ color: colors.textSecondary }}>Carbs</p>
                </div>
                <div className="p-2 rounded-lg" style={{ backgroundColor: colors.card }}>
                  <p className="text-xl font-bold" style={{ color: colors.primary }}>{product.nutrition.fat}</p>
                  <p className="text-xs" style={{ color: colors.textSecondary }}>Fat</p>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-2 text-sm" style={{ color: colors.textSecondary }}>
              <span className="font-medium" style={{ color: colors.text }}>Ingredients:</span>
              <span>{product.ingredients}</span>
            </div>

            <button className="flex items-center gap-2 text-sm transition-all hover:scale-105" style={{ color: colors.primary }}>
              <FaShare /> Share
            </button>
          </div>
        </div>
      </div>

      {/* Similar Items */}
      <div className="mt-12">
        <h2 className="text-2xl font-bold mb-4 flex items-center gap-2" style={{ color: colors.text }}>
          <FaShoppingBag style={{ color: colors.primary }} /> Similar Items You Might Like
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4">
          {similarItems.map((item) => (
            <div 
              key={item.id}
              className="rounded-2xl overflow-hidden cursor-pointer hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group"
              style={{ backgroundColor: colors.card, border: `1px solid ${colors.border}` }}
              onClick={() => navigate(`/product/${item.id}`)}
            >
              <div className="relative h-48 overflow-hidden">
                <img src={item.image} alt={item.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                <div className="absolute top-2 left-2 px-2 py-0.5 rounded-full text-xs font-semibold flex items-center gap-1" style={{ backgroundColor: 'rgba(0,0,0,0.7)', color: 'white' }}>
                  <FaStar className="text-yellow-400 text-[10px]" /> {item.rating}
                </div>
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <span className="text-white text-sm font-semibold flex items-center gap-2 px-4 py-2 rounded-full" style={{ backgroundColor: colors.primary }}>
                    <FaEye /> View Details
                  </span>
                </div>
              </div>
              <div className="p-3">
                <div className="flex items-center gap-2">
                  <span className={`w-2 h-2 rounded-full ${item.isVeg ? 'bg-green-500' : 'bg-red-500'}`}></span>
                  <h4 className="font-semibold text-sm" style={{ color: colors.text }}>{item.name}</h4>
                </div>
                <p className="text-xs" style={{ color: colors.textSecondary }}>{item.category}</p>
                <div className="flex justify-between items-center mt-2">
                  <span className="font-bold" style={{ color: colors.primary }}>₹{item.price}</span>
                  <span className="text-xs flex items-center gap-1" style={{ color: colors.textSecondary }}>
                    <FaStar className="text-yellow-400 text-[10px]" /> {item.rating}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ✅ Schedule Modal - Multiple Date Selection */}
      <AnimatePresence>
        {showScheduleModal && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center px-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}
            onClick={() => setShowScheduleModal(false)}
          >
            <motion.div
              className="rounded-2xl p-6 max-w-lg w-full max-h-[90vh] overflow-y-auto"
              initial={{ scale: 0.9, y: 20 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.9, y: 20 }}
              style={{ backgroundColor: colors.card, border: `1px solid ${colors.border}` }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-bold" style={{ color: colors.text }}>📅 Schedule Order</h3>
                <button className="text-2xl hover:scale-110 transition-transform" style={{ color: colors.textSecondary }} onClick={() => setShowScheduleModal(false)}>×</button>
              </div>

              {/* Meal Info */}
              <div className="p-3 rounded-xl mb-4 flex items-center gap-3" style={{ backgroundColor: colors.inputBackground, border: `1px solid ${colors.border}` }}>
                <img src={product.image} alt={product.name} className="w-16 h-16 rounded-xl object-cover" />
                <div>
                  <p className="font-semibold" style={{ color: colors.text }}>{product.name}</p>
                  <p className="text-sm" style={{ color: colors.textSecondary }}>₹{product.price}</p>
                </div>
              </div>

              {/* Quantity */}
              <div className="mb-4">
                <label className="text-sm font-medium block mb-1" style={{ color: colors.textSecondary }}>Quantity</label>
                <div className="flex items-center gap-4">
                  <button className="w-10 h-10 rounded-full border flex items-center justify-center transition-all hover:scale-105 active:scale-95" style={{ borderColor: colors.border, color: colors.text, backgroundColor: colors.inputBackground }} onClick={() => setQuantity(Math.max(1, quantity - 1))}><FaMinus /></button>
                  <span className="text-xl font-bold min-w-[30px] text-center" style={{ color: colors.text }}>{quantity}</span>
                  <button className="w-10 h-10 rounded-full border flex items-center justify-center transition-all hover:scale-105 active:scale-95" style={{ borderColor: colors.border, color: colors.text, backgroundColor: colors.inputBackground }} onClick={() => setQuantity(quantity + 1)}><FaPlus /></button>
                </div>
              </div>

              {/* Date Selection */}
              <div className="mb-4">
                <label className="text-sm font-medium block mb-1" style={{ color: colors.textSecondary }}>Add Delivery Date</label>
                <div className="flex items-center justify-between p-3 rounded-xl cursor-pointer hover:shadow-md transition-all active:scale-[0.98]" style={{ backgroundColor: colors.inputBackground, border: `1px solid ${colors.border}` }} onClick={() => setShowCalendar(!showCalendar)}>
                  <span style={{ color: colors.text }}>{formatDate(tempDate)}</span>
                  <FaCalendarAlt style={{ color: colors.primary }} />
                </div>
                {showCalendar && (
                  <div className="mt-2 p-3 rounded-xl" style={{ backgroundColor: colors.card, border: `1px solid ${colors.border}` }}>
                    <Calendar onChange={handleDateSelect} value={tempDate} minDate={new Date()} className="w-full" tileClassName="hover:bg-primary hover:text-white transition-colors" />
                  </div>
                )}
              </div>

              {/* Meal Type */}
              <div className="mb-4">
                <label className="text-sm font-medium block mb-1" style={{ color: colors.textSecondary }}>Meal Time</label>
                <div className="grid grid-cols-3 gap-2">
                  {mealTypes.map((type) => (
                    <button key={type} className={`py-2 px-3 rounded-xl text-sm font-medium transition-all hover:scale-105 active:scale-95 ${selectedMealType === type ? 'border-2' : 'border'}`} style={{ borderColor: selectedMealType === type ? colors.primary : colors.border, backgroundColor: selectedMealType === type ? colors.primary + '20' : colors.inputBackground, color: selectedMealType === type ? colors.primary : colors.text }} onClick={() => setSelectedMealType(type)}>{type}</button>
                  ))}
                </div>
              </div>

              {/* Time Slot */}
              <div className="mb-4">
                <label className="text-sm font-medium block mb-1" style={{ color: colors.textSecondary }}>Time Slot</label>
                <div className="grid grid-cols-3 gap-2 max-h-32 overflow-y-auto p-1">
                  {timeSlots.slice(0, 18).map((time) => (
                    <button key={time} className={`py-2 px-2 rounded-xl text-xs font-medium transition-all hover:scale-105 active:scale-95 ${selectedTime === time ? 'border-2' : 'border'}`} style={{ borderColor: selectedTime === time ? colors.primary : colors.border, backgroundColor: selectedTime === time ? colors.primary + '20' : colors.inputBackground, color: selectedTime === time ? colors.primary : colors.text }} onClick={() => setSelectedTime(time)}>{time}</button>
                  ))}
                </div>
              </div>

              {/* Add Date Button */}
              <button className="w-full py-2.5 rounded-xl text-sm font-semibold transition-all hover:scale-105 active:scale-95 flex items-center justify-center gap-2 mb-4" style={{ backgroundColor: colors.primary + '20', color: colors.primary, border: `2px dashed ${colors.primary}` }} onClick={handleAddDate}>
                <FaPlus /> Add This Date
              </button>

              {/* Selected Dates List */}
              {selectedDates.length > 0 && (
                <div className="mb-4">
                  <label className="text-sm font-medium block mb-2" style={{ color: colors.textSecondary }}>Selected Dates ({selectedDates.length})</label>
                  <div className="space-y-2 max-h-40 overflow-y-auto">
                    {selectedDates.map((schedule, index) => (
                      <div key={index} className="flex items-center justify-between p-2 rounded-lg" style={{ backgroundColor: colors.inputBackground, border: `1px solid ${colors.border}` }}>
                        <div className="text-xs">
                          <span className="font-semibold" style={{ color: colors.text }}>{formatDateShort(schedule.date)}</span>
                          <span className="ml-2" style={{ color: colors.textSecondary }}>{schedule.mealType} • {schedule.time}</span>
                          <span className="ml-2" style={{ color: colors.primary }}>x{schedule.quantity}</span>
                        </div>
                        <button className="w-7 h-7 rounded-full flex items-center justify-center transition-all hover:scale-110 active:scale-95" style={{ backgroundColor: '#C6282820', color: '#C62828' }} onClick={() => handleRemoveDate(schedule.date)}><FaTrash className="text-xs" /></button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Order Summary */}
              <div className="p-3 rounded-xl mb-4" style={{ backgroundColor: colors.primary + '15', border: `1px solid ${colors.primary}30` }}>
                <p className="text-sm font-medium" style={{ color: colors.primary }}>📋 Order Summary</p>
                <div className="flex justify-between text-sm mt-1" style={{ color: colors.text }}>
                  <span>{product.name} x{quantity} × {selectedDates.length || 1} days</span>
                  <span>₹{product.price * quantity * (selectedDates.length || 1)}</span>
                </div>
                <div className="text-xs mt-1" style={{ color: colors.textSecondary }}>{selectedDates.length} date{selectedDates.length !== 1 ? 's' : ''} scheduled</div>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-3">
                <button className="flex-1 py-3 rounded-xl font-semibold transition-all hover:scale-105 active:scale-95" style={{ backgroundColor: selectedDates.length > 0 ? colors.primary : colors.border, color: selectedDates.length > 0 ? '#FFFFFF' : colors.textSecondary, cursor: selectedDates.length > 0 ? 'pointer' : 'not-allowed' }} onClick={handleConfirmAllSchedules} disabled={selectedDates.length === 0}>
                  ✅ Confirm All ({selectedDates.length})
                </button>
                <button className="flex-1 py-3 rounded-xl font-semibold transition-all hover:scale-105 active:scale-95" style={{ backgroundColor: colors.border, color: colors.text }} onClick={() => setShowScheduleModal(false)}>Cancel</button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default ProductDetails;